
import WLHomepageItemSeo from './HomepageItemSeo/WLHomepageItemSeo.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IPartnerSEOProductResult } from '@homeserve/od-typings/api';

@Component({
  components: {
    WLHomepageItemSeo,
  },
})
export default class WLHomepageProductsSeo extends Vue {
  @Prop()
  private products!: IPartnerSEOProductResult;

  @Prop()
  private limit!: number;
}
